import Albums from "./albums/albums.js";

const AlbumContainer = () =>
{
  return (
    <>
      <Albums />
    </>
  );
}

export default AlbumContainer;